module.exports = __webpack_public_path__ + "ida-a4f6ad510ca8190a479017bfc31a2025.webp";